import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box, Flex } from '@atlaskit/primitives/compiled';

import { useIsSingleColumn } from '../../../controllers/layout';

type ProfileContentProps = {
	children: React.ReactNode;
};

const styles = cssMap({
	root: {
		width: '100%',
		maxWidth: `1232px`,
		margin: '0 auto',
	},
	flexColumn: {
		flexDirection: 'column',
	},
	grid: {
		display: 'grid',
		gridTemplateColumns: '320px minmax(0, 1fr)',
		width: '100%',
	},
});

export const ProfileContent = ({ children }: ProfileContentProps) => {
	const isSingleColumn = useIsSingleColumn();

	return (
		<Box xcss={styles.root}>
			<Flex xcss={cx(isSingleColumn ? styles.flexColumn : styles.grid)}>{children}</Flex>
		</Box>
	);
};
